import { render } from "./HeaderProfileMenu.vue?vue&type=template&id=8d8122f4&scoped=true"
import script from "./HeaderProfileMenu.vue?vue&type=script&lang=js"
export * from "./HeaderProfileMenu.vue?vue&type=script&lang=js"

import "./HeaderProfileMenu.vue?vue&type=style&index=0&id=8d8122f4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d8122f4"]])

export default __exports__